// External deps

import { ContentCard } from 'ypf-pas-general-ui-components';
import { TbClipboardList } from 'react-icons/tb';
import { IoSearch } from 'react-icons/io5';
// Internal deps
import PropTypes from 'prop-types';
import './NoWorkReports.scss';

const NoWorkReports = ({ title, subtitle, firstRender }) => (
  <div className="noworkreports-container">
    <ContentCard className="icon-clipboard-container" orientation="vertical-horizontal">
      {firstRender ? <IoSearch /> : <TbClipboardList />}
    </ContentCard>
    <p>
      <strong>{title || 'No disponés de ninguna línea de parte de trabajo'}</strong>
    </p>
    <p>{subtitle || 'Agregá líneas para poder cargar cantidades trabajadas'}</p>
  </div>
);

NoWorkReports.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  firstRender: PropTypes.bool
};

NoWorkReports.defaultProps = {
  title: '',
  subtitle: '',
  firstRender: false
};

export default NoWorkReports;
